export default __webpack_public_path__ + "static/media/tensorflow_services.1b38a089.png";